import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { downloadEstadoNomina } from "../../../../redux/actions/nte";
import { getPuestos, getSectores } from "../../../../redux/actions/resolucion";
import { downloadFile } from "../../../../util/files";
import DatosEstablecimientoHeaderLabel from "../commons/labels/DatosEstablecimientoHeaderLabel";
import ConfeccionDelArchivoForm from "./ConfeccionDelArchivoForm";

const initialValues = {
    idSector: null,
    idPuesto: null,
};

const ConfeccionDelArchivoContainer = ({ nextForm }) => {
    const dispatch = useDispatch();
    const idDependenciaEmpleador = useSelector(
        (state) => state.nte.searchedNte
    );
    const [loading, setLoading] = useState(false);
    const [isDownloadingNominas, setIsDownloadingNominas] = useState(false);
    useEffect(() => {
        setLoading(true);
        Promise.all([
            dispatch(getPuestos(idDependenciaEmpleador)),
            dispatch(getSectores(idDependenciaEmpleador)),
        ]).finally(() => {
            setLoading(false);
        });

    }, [idDependenciaEmpleador]);


    const handleDescargarNominas = () => {
        setIsDownloadingNominas(true);
        dispatch(downloadEstadoNomina(idDependenciaEmpleador))
            .then((res) => {
                downloadFile(res?.value?.data, res.value.fileName).then((_) => {
                    setIsDownloadingNominas(false);
                });
            })
            .catch((err) => {
                toast.error(err);
                setIsDownloadingNominas(false);
            });
    };

    return (
        <>
            <DatosEstablecimientoHeaderLabel />
            <ConfeccionDelArchivoForm
                initialValues={initialValues}
                onSubmit={() => { nextForm('Responsables') }}
                loading={loading}
                idDependenciaEmpleador={idDependenciaEmpleador}
                isDownloadingNominas={isDownloadingNominas}
                handleDescargarNominas={handleDescargarNominas}
            />

        </>
    );
};

export default ConfeccionDelArchivoContainer;